import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback } from 'react';
import MediaSelector from '../../MediaPopup/MediaSelector';
import MediaManager from '../../MediaPopup/MediaManager';
/**
 * Contains all the related supporting components editor needs
 */ const EditorCommon = ({ mediaSelectorProps, onSelect, setMediaSelectorProps, mediaManagerProps, onManageDone, setMediaManagerProps })=>{
    const onClose = useCallback(()=>{
        setMediaSelectorProps(undefined);
        onSelect([]);
    }, [
        onSelect,
        setMediaSelectorProps
    ]);
    const onCloseManager = useCallback(()=>{
        setMediaManagerProps(undefined);
        onManageDone([]);
    }, [
        onManageDone,
        setMediaManagerProps
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, mediaSelectorProps && /*#__PURE__*/ React.createElement(MediaSelector, _object_spread_props(_object_spread({}, mediaSelectorProps), {
        onSelect: onSelect,
        onClose: onClose
    })), mediaManagerProps && /*#__PURE__*/ React.createElement(MediaManager, _object_spread_props(_object_spread({}, mediaManagerProps), {
        onDone: onManageDone,
        onClose: onCloseManager
    })));
};
EditorCommon.displayName = 'EditorCommon';
export default EditorCommon;

//# sourceMappingURL=EditorCommon.js.map